module.exports = __webpack_public_path__ + "media/images/icons/plus-402c3d24f021a54b024eccd2c90f23df.svg";